module.exports = __webpack_public_path__ + "static/img/background.b165126.jpg";